import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CommercialMemoPage() {
    const navigate = useNavigate();
    const [line, setLine] = useState('');
    const [notes, setNotes] = useState([]);

    const addNote = (type) => { // type: 'pain', 'dream', 'budget', 'constraint'
        if (!line.trim()) return;
        setNotes([...notes, { id: Date.now(), text: line, type }]);
        setLine('');
    };

    const getTypeColor = (type) => {
        switch (type) {
            case 'pain': return '#ef4444';   // Red
            case 'dream': return '#eab308';  // Gold
            case 'budget': return '#22c55e'; // Green
            case 'fact': return '#3b82f6';   // Blue
            default: return 'white';
        }
    };

    const getIcon = (type) => {
        switch (type) {
            case 'pain': return '🔴 Problème';
            case 'dream': return '💡 Idée/Rêve';
            case 'budget': return '💰 Budget';
            case 'fact': return 'ℹ️ Info';
            default: return '';
        }
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#0f172a', color: 'white', fontFamily: 'Inter, sans-serif', padding: 40, display: 'flex', gap: 40 }}>

            {/* INPUT AREA */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                    <h1 style={{ fontSize: '2rem' }}>📝 Smart Memo</h1>
                    <button onClick={() => navigate('/commercial/launchpad')} style={{ background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.3)', cursor: 'pointer' }}>Retour</button>
                </div>

                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>

                    <input
                        autoFocus
                        type="text"
                        placeholder="Tapez ici..."
                        value={line}
                        onChange={e => setLine(e.target.value)}
                        onKeyDown={e => { if (e.key === 'Enter') addNote('fact'); }}
                        style={{
                            width: '100%', padding: '30px', borderRadius: 24, border: 'none', background: '#1e293b',
                            fontSize: '2rem', color: 'white', marginBottom: 20, outline: 'none'
                        }}
                    />

                    <div style={{ display: 'flex', gap: 15 }}>
                        <button onClick={() => addNote('pain')} style={{ flex: 1, padding: 20, background: '#ef4444', border: 'none', borderRadius: 16, color: 'white', fontSize: '1.2rem', fontWeight: 700, cursor: 'pointer', opacity: line ? 1 : 0.5 }}>🔴 DOULEUR</button>
                        <button onClick={() => addNote('dream')} style={{ flex: 1, padding: 20, background: '#eab308', border: 'none', borderRadius: 16, color: 'black', fontSize: '1.2rem', fontWeight: 700, cursor: 'pointer', opacity: line ? 1 : 0.5 }}>💡 IDÉE / RÊVE</button>
                        <button onClick={() => addNote('budget')} style={{ flex: 1, padding: 20, background: '#22c55e', border: 'none', borderRadius: 16, color: 'white', fontSize: '1.2rem', fontWeight: 700, cursor: 'pointer', opacity: line ? 1 : 0.5 }}>💰 BUDGET</button>
                        <button onClick={() => addNote('fact')} style={{ flex: 1, padding: 20, background: '#3b82f6', border: 'none', borderRadius: 16, color: 'white', fontSize: '1.2rem', fontWeight: 700, cursor: 'pointer', opacity: line ? 1 : 0.5 }}>ℹ️ INFO</button>
                    </div>

                </div>
            </div>

            {/* RESULTS AREA */}
            <div style={{ width: 400, background: '#1e293b', borderRadius: 24, padding: 30, overflowY: 'auto' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: 20, opacity: 0.7 }}>Synthèse</h2>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                    {notes.map(note => (
                        <div key={note.id} className="animate-slide-in" style={{ background: 'rgba(255,255,255,0.05)', padding: 15, borderRadius: 12, borderLeft: `5px solid ${getTypeColor(note.type)}` }}>
                            <div style={{ fontSize: '0.8rem', color: getTypeColor(note.type), fontWeight: 700, textTransform: 'uppercase', marginBottom: 5 }}>
                                {getIcon(note.type)}
                            </div>
                            <div style={{ fontSize: '1.1rem' }}>{note.text}</div>
                        </div>
                    ))}
                    {notes.length === 0 && <div style={{ opacity: 0.3, textAlign: 'center' }}>Aucune note...</div>}
                </div>

                {notes.length > 0 && (
                    <button style={{ width: '100%', marginTop: 40, padding: 15, borderRadius: 50, border: 'none', background: 'white', color: 'black', fontWeight: 700, cursor: 'pointer' }}>
                        Copier le Rapport 📋
                    </button>
                )}
            </div>

            <style>{`.animate-slide-in { animation: slideIn 0.3s ease-out; } @keyframes slideIn { from { opacity: 0; transform: translateX(20px); } to { opacity: 1; transform: translateX(0); } }`}</style>
        </div>
    );
}
